import { cn } from '~/shadcn/lib/utils'

export type SortDir = 'asc' | 'desc'

type Props = {
  active: boolean
  dir: SortDir
}

export function SortArrows({ active, dir }: Props) {
  return (
    <span className="ml-1 inline-flex flex-col leading-none">
      <span
        className={cn(
          'text-[8px]',
          active && dir === 'asc' ? 'text-white' : 'text-white/40'
        )}>
        ▲
      </span>
      <span
        className={cn(
          'text-[8px]',
          active && dir === 'desc' ? 'text-white' : 'text-white/40'
        )}>
        ▼
      </span>
    </span>
  )
}
